exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "period-list-mobile .container.hpd.responsiveMobile{padding-left:0;padding-right:0}@media only screen and (device-width:375px)and (device-height:812px)and (-webkit-device-pixel-ratio:3){period-list-mobile .container.hpd.responsiveMobile{padding-bottom:30px}}period-list-mobile .container.hpd.responsiveMobile.is-inception{padding-top:128px}period-list-mobile .period-list-filters{padding-top:10px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/periodListMobile/periodListMobile.scss
// module id = 1354
// module chunks = 0